<template>
	<div class="case-filter">
		<b-container>
			<h2 class="main-ttl d-block d-md-none">Фильтровать</h2>
			<div class="d-flex flex-column flex-md-row justify-content-start align-items-center">
				<button class="btn-city d-flex justify-content-start align-items-center" @click="show = !show">
					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="30" viewBox="0 0 26 30" fill="none">
						<path
							d="M24.25 12.5C24.25 21.25 13 28.75 13 28.75C13 28.75 1.75 21.25 1.75 12.5C1.75 9.51631 2.93526 6.65483 5.04505 4.54505C7.15483 2.43526 10.0163 1.25 13 1.25C15.9837 1.25 18.8452 2.43526 20.955 4.54505C23.0647 6.65483 24.25 9.51631 24.25 12.5Z"
							stroke="#B33031" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<path
							d="M13 16.25C15.0711 16.25 16.75 14.5711 16.75 12.5C16.75 10.4289 15.0711 8.75 13 8.75C10.9289 8.75 9.25 10.4289 9.25 12.5C9.25 14.5711 10.9289 16.25 13 16.25Z"
							stroke="#B33031" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					<p class="btn-city-label">{{currentCity}}</p>
					<svg class="arrow" :class="{'rotate': show}" xmlns="http://www.w3.org/2000/svg" width="17" height="10"
					     viewBox="0 0 17 10" fill="none">
						<path d="M1 1L8.5 8L16 1" stroke="#626262" stroke-width="2"/>
					</svg>
					<transition name="slide-fade">
						<div class="city-cont d-flex flex-column justify-content-start align-items-start" v-if="show">
							<a
								v-for="(item, index) in cityes"
								:key="index"
								@click.prevent="filteringCity(item.title)"
							>{{item.title}}</a>
						</div>
					</transition>
				</button>
				<button class="btn-service d-flex justify-content-between align-items-center" @click="show2 = !show2">
					<p class="btn-service-label">{{currentServ}}</p>
					<svg class="arrow" :class="{'rotate': show2}" xmlns="http://www.w3.org/2000/svg" width="17" height="10"
					     viewBox="0 0 17 10" fill="none">
						<path d="M1 1L8.5 8L16 1" stroke="#626262" stroke-width="2" fill=""/>
					</svg>
					<transition name="slide-fade">
						<div class="service-cont d-flex flex-column flex-lg-row align-items-start" v-if="show2">
							<div class="service-item d-flex flex-column justify-content-start align-items-start"
							     v-for="(item, index) in services.servicescat" v-if="item.title = 'title'">
								<div class="d-flex flex-column justify-content-between align-items-start" >
									<a
										:to="{path: $route.path.replace('/api', ''), query:{serv:serv.title}}"
										v-for="(serv, index) in item.service"
										@click.prevent="filteringServ(serv.title)"
									>{{serv.title}}</a>
								</div>
							</div>
						</div>
					</transition>
				</button>
			</div>
		</b-container>
	</div>
</template>

<script>
	const axios = require('axios');
	export default {
		data() {
			return {
				cityes: null,
				services: null,
				show: false,
				show2: false,
				currentCity: this.$route.query.city,
				currentServ: this.$route.query.serv,
			}
		},
		created() {
			if (this.$route.query.city == undefined || this.$route.query.serv == undefined) {
				this.currentCity = 'Тюмень';
				this.currentServ = 'Монтаж';
			}
			axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=filter_city`,
				{responseType: 'json'}
			).then(({data}) => {
				this.cityes = JSON.parse(data.addons);
			});
			axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=filter_services`,
				{responseType: 'json'}
			).then(({data}) => {
				this.services = JSON.parse(data.addons);
			});
		},
		methods: {
			filteringCity(city) {
			this.currentCity = city;
			this.$router.push({path: this.$route.path, query:{city:this.currentCity,serv:this.currentServ}}).catch(err => {})
			},
			// filteringServcat(servcat) {
			// 	this.currentServ = servcat;
			// 	this.$router.push({path: this.$route.path, query:{city:this.currentCity,serv:this.currentServ}}).catch(err => {})
			// 	///потом
			// },
			filteringServ(serv) {
				this.currentServ = serv;
				this.$router.push({path: this.$route.path, query:{city:this.currentCity,serv:this.currentServ}}).catch(err => {})
			},
		}
	}


</script>

<style lang="scss" scoped>
	
	.case-filter {
		background-color: #FFFFFF;
		padding: 64px 0 40px 25%;
		@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
			padding: 30px 15px;
		}
		
		.main-ttl {
			font-weight: 500;
			font-size: 22px;
			line-height: 110%;
			color: #626262;
			margin-bottom: 20px;
		}
		
		.btn-city {
			position: relative;
			width: 255px;
			height: 48px;
			border: 1px solid #D2D2D2;
			border-radius: 6px;
			background-color: #FFFFFF;
			padding: 0 16px;
			transition: all 0.3s ease-in-out;
			margin-right: 20px;
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				margin-right: 0;
				margin-bottom: 15px;
			}
			
			svg {
				flex-shrink: 0;
			&:not(.arrow) {
				margin-right: 15px;
			}
				path {
					transition: all 0.3s ease-in-out;
				}
				
			}
			
			&-label {
				font-size: 16px;
				line-height: 110%;
				color: $secondFontColor;
				transition: all 0.3s ease-in-out;
				flex-grow: 3;
				text-align: left;
			}
		}
		
		.btn-service {
			position: relative;
			width: 255px;
			height: 48px;
			border: 1px solid #D2D2D2;
			box-sizing: border-box;
			border-radius: 6px;
			background-color: #FFFFFF;
			padding: 0 16px;
			transition: all 0.3s ease-in-out;
			
			&-label {
				font-size: 16px;
				line-height: 100%;
				text-transform: lowercase;
				color: $secondFontColor;
				transition: all 0.3s ease-in-out;
			}
		}
		
		.btn-city, .btn-service {
			.arrow {
				transform: rotate(180deg);
				transition: all 0.3s ease-in-out;
				
				&.rotate {
					transform: rotate(0);
				}
			}
			
			&:hover {
				background-color: $bg2Color;
				border: 1px solid $bg2Color;
				
				.btn-city-label, .btn-service-label {
					color: $activeColor;
				}
				
				svg {
					path {
						stroke: $activeColor
					}
				}
			}
		}
		
		.city-cont {
			position: absolute;
			top: 130%;
			left: 0;
			width: 100%;
			transform: translateY(0);
			padding: 5px 8px 3px 8px;
			background: #FFFFFF;
			box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.3);
			border-radius: 6px;
			z-index: 10;
			
			a {
				margin-top: 10px;
				font-weight: 500;
				font-size: 12px;
				line-height: 15px;
				text-transform: uppercase;
				color: $secondFontColor;
				transition: all 0.3s ease-in-out;
				
				&:hover {
					color: $activeColor;
				}
			}
		}
		
		.service-cont {
			position: absolute;
			top: 130%;
			left: 0;
			transform: translateY(0);
			padding: 20px;
			background: #FFFFFF;
			box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.3);
			border-radius: 6px;
			z-index: 10;
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				height: 335px;
				overflow-y: scroll;
			}
			
			.service-item {
				margin-right: 30px;
			}
			
			a {
				font-size: 14px;
				line-height: 18px;
				color: $secondFontColor;
				margin-top: 10px;
				text-align: left;
				transition: all 0.3s ease-in-out;
				
				&:hover {
					color: $activeColor;
				}
				
				&.category {
					height: 30px;
					font-weight: 800;
					color: $mainFontColor;
					transition: all 0.3s ease-in-out;
					text-transform: uppercase;
					@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
						height: auto;
						margin-top: 10px;
					}
					
					&:hover {
						color: $activeColor;
					}
				}
			}
		}
		
		.slide-fade {
			&-enter-active, &-leave-active {
				transition: all 0.3s ease-in-out;
			}
			
			&-enter, &-leave-to {
				transform: translateY(50px);
				opacity: 0;
			}
		}
		
	}

</style>